class LyleTimeline extends HTMLElement {
  #triggers = [];
  #entries = [];
  #media = [];
  #descriptions = [];
  #desktopQuery = null;

  connectedCallback() {
    this.#triggers = Array.from(
      this.querySelectorAll("[data-timeline-trigger]"),
    );
    this.#entries = Array.from(this.querySelectorAll("[data-timeline-entry]"));
    this.#media = Array.from(this.querySelectorAll("[data-timeline-media]"));
    this.#descriptions = Array.from(
      this.querySelectorAll("[data-timeline-description]"),
    );

    this.#desktopQuery = window.matchMedia("(min-width: 1024px)");

    for (const trigger of this.#triggers) {
      trigger.addEventListener("click", this.#handleTriggerActivate);
    }

    for (const entry of this.#entries) {
      entry.addEventListener("mouseenter", this.#handleEntryActivate);
      entry.addEventListener("focusin", this.#handleEntryActivate);
    }

    this.#setActive(0);
  }

  disconnectedCallback() {
    for (const trigger of this.#triggers) {
      trigger.removeEventListener("click", this.#handleTriggerActivate);
    }

    for (const entry of this.#entries) {
      entry.removeEventListener("mouseenter", this.#handleEntryActivate);
      entry.removeEventListener("focusin", this.#handleEntryActivate);
    }
  }

  #handleTriggerActivate = (event) => {
    const index = Number(event.currentTarget.dataset.timelineTrigger);
    this.#setActive(index);
  };

  #handleEntryActivate = (event) => {
    const index = Number(event.currentTarget.dataset.timelineEntry);
    this.#setActive(index);
  };

  #setActive(index) {
    for (const trigger of this.#triggers) {
      const isActive = Number(trigger.dataset.timelineTrigger) === index;
      trigger.classList.toggle("is-active", isActive);
      trigger.setAttribute("aria-pressed", isActive ? "true" : "false");

      if (isActive && !this.#desktopQuery?.matches) {
        trigger.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    }

    for (const entry of this.#entries) {
      const isActive = Number(entry.dataset.timelineEntry) === index;
      entry.classList.toggle("is-active", isActive);
    }

    for (const image of this.#media) {
      image.classList.toggle(
        "is-active",
        Number(image.dataset.timelineMedia) === index,
      );
    }

    for (const description of this.#descriptions) {
      description.classList.toggle(
        "is-active",
        Number(description.dataset.timelineDescription) === index,
      );
    }
  }
}

if (!customElements.get("lyle-timeline")) {
  customElements.define("lyle-timeline", LyleTimeline);
}
